import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useWorkspaces } from '@/features/workspaces/hooks';
import { useWorkspaceStore } from '@/features/workspaces/store';
import { getWorkspaceColor } from '@/features/workspaces/utils/avatarColor';
function SkeletonAvatar() {
    return (_jsx("div", { className: "w-8 h-8 rounded-lg bg-surface-container animate-pulse shrink-0", "aria-hidden": "true" }));
}
function WorkspaceIcon({ workspace, isActive, onSelect }) {
    const initial = workspace.name.charAt(0).toUpperCase();
    const handleClick = () => {
        if (!isActive) {
            onSelect(workspace.id, workspace.name);
        }
    };
    return (_jsxs("button", { type: "button", onClick: handleClick, title: workspace.name, className: "relative flex items-center justify-center w-8 h-8 rounded-lg shrink-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary", style: isActive ? undefined : { backgroundColor: getWorkspaceColor(workspace.id) }, children: [isActive && (_jsx("span", { className: "absolute left-0 top-1/2 -translate-y-1/2 w-[3px] h-4 bg-primary rounded-r-full", "aria-hidden": "true" })), _jsx("span", { className: [
                    'flex items-center justify-center w-full h-full rounded-lg',
                    isActive ? 'bg-primary-container' : '',
                ].join(' '), children: _jsx("span", { className: [
                        'text-[13px] font-semibold leading-none select-none',
                        isActive ? 'text-primary' : 'text-white',
                    ].join(' '), children: initial }) })] }));
}
export function WorkspaceRail({ orientation = 'vertical' }) {
    const { data: workspaces, isLoading } = useWorkspaces();
    const selectedWorkspaceId = useWorkspaceStore((s) => s.selectedWorkspaceId);
    const selectWorkspace = useWorkspaceStore((s) => s.selectWorkspace);
    const isVertical = orientation === 'vertical';
    const containerClass = isVertical
        ? 'flex flex-col items-center gap-2 py-3 overflow-y-auto flex-1'
        : 'flex flex-row items-center gap-2 px-3 overflow-x-auto py-2';
    if (isLoading) {
        return (_jsxs("div", { className: containerClass, children: [_jsx(SkeletonAvatar, {}), _jsx(SkeletonAvatar, {}), _jsx(SkeletonAvatar, {})] }));
    }
    if (!workspaces || workspaces.length === 0) {
        return _jsx("div", { className: containerClass });
    }
    return (_jsx("div", { className: containerClass, children: workspaces.map((workspace) => (_jsx(WorkspaceIcon, { workspace: workspace, isActive: workspace.id === selectedWorkspaceId, onSelect: selectWorkspace }, workspace.id))) }));
}
